// extracted by mini-css-extract-plugin
export default {"mainCenter":"saradnja_mainCenter__Lvp9r"};